import { jsPDF } from 'jspdf';
import { BLAZEMETER_LOGO_PNG } from './blazemeterLogo';

// Primary brand color (#5405FF) as RGB — used for table headers in place of the
// jspdf-autotable default blue. Shared across all Admin PDF exports.
export const BRAND_PRIMARY_RGB: [number, number, number] = [84, 5, 255];

// Places the BlazeMeter logo in the top-right corner of the current page (aspect ratio
// 171:42 preserved). Kept in the top strip (y 18–46) so it stays clear of any header text
// below it. Works for both portrait and landscape pages via the page width.
export const addBrandLogo = (doc: jsPDF): void => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const logoWidth = 114;
  const logoHeight = (logoWidth * 42) / 171;
  doc.addImage(BLAZEMETER_LOGO_PNG, 'PNG', pageWidth - 40 - logoWidth, 18, logoWidth, logoHeight);
};
